import { Stack } from '@chakra-ui/react';
import { SearchField } from './SearchField';
import SearchOptions from './SearchOptions';

export default function Search() {
  return (
    <Stack
      p={2}
      width={'100%'}
      maxWidth={400}
      borderRadius="0.375rem"
    >
      <SearchField />
      <SearchOptions />
    </Stack>
  );
}
